import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Loading } from 'adc-ui-components';
import { getIdmAuth } from '../helpers/auth';
import { dispatchSetModal } from '../shared/actions/userMessagesActions';
import { UNHANDLED_ERROR } from '../components/modals/ModalHandler';
import { BaseDataLayer, PageTracking } from '../helpers/dataLayer';

export default ({ children, redirectTo = '' }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    const getAuth = async () => {
      try {
        const login = await getIdmAuth(redirectTo);

        // Remove the loading dots unless getOauth is about to redirect.
        setLoading(!!login.forceRedirect);
      } catch (err) {
        dispatch(dispatchSetModal({ showModal: true, type: UNHANDLED_ERROR }));
      }
    };

    getAuth();
  }, [dispatch, redirectTo]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <BaseDataLayer />
      <PageTracking />
      {children}
    </>
  );
};
